"use client";
import { getLogger } from "@/utils/logger";


import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search as SearchIcon } from "lucide-react";

const log = getLogger("Search");

export default function Search({ query, setQuery }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    // You can add additional search submission logic if needed
    log.info(
      `[Search:handleSubmit] > [Request]: submitSearch > [Response]: submitted > [Comment]: query=${query || "<empty>"}`
    );
  };

  return (
    <form
      action="#"
      method="POST"
      onSubmit={handleSubmit}
      className="w-full"
      id='search-form-submit'>
      <div className="relative flex items-center gap-2 rounded-lg border border-[#324c48]/60 bg-white px-2 py-0.5 focus-within:border-[#D4A017] focus-within:ring-1 focus-within:ring-[#D4A017]">
        <Input
          type="text"
          placeholder="Search by title, street, state, zip, area, APN, tags, city, or county"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="h-8 w-full border-0 bg-transparent px-2 text-sm text-[#030001] placeholder-[#576756] focus-visible:ring-0 focus-visible:ring-offset-0"
          required
          id='search-input-set-query' />
        <Button
          type="submit"
          size="icon"
          className="h-8 w-8 shrink-0 rounded-md bg-[#324c48] hover:bg-[#3f4f24] text-white"
          aria-label="Search"
          id='search-btn-search'>
          <SearchIcon className="h-4 w-4" />
        </Button>
      </div>
    </form>
  );
}
